import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import styles from "./Barchart.module.css";
import { getcetGraph } from "../../../services/summary/summaryService";

const Barchart = ({ filterdata , activeTab }) => {
  const svgRef = useRef(null);
  const wrapperRef = useRef(null);
  const [mode, setMode] = useState("CAN");

  const [graphData, setGraphData] = useState([]);


  useEffect(() => {
    if (filterdata?.startDate && filterdata?.endDate && filterdata?.vehicle) {
      getGraphFunction_cet();
    }
  }, [filterdata?.startDate, filterdata?.endDate, filterdata?.vehicle,activeTab]);

  async function getGraphFunction_cet() {
    await getcetGraph({ filterdata,activeTab })
      .then(res => {
        setGraphData(res);
      })
      .catch(err => console.log("Something went wrong"));
  }

  const DATA_MAP = {
    CAN: graphData?.map(d => ({
      label: d.date,
      value: d.can
    })) || [],

    EVENT: graphData?.map(d => ({
      label: d.date,
      value: d.event
    })) || [],

    TELEMETRY: graphData?.map(d => ({
      label: d.date,
      value: d.telemetry
    })) || []
  };

  useEffect(() => {

    const data = DATA_MAP[mode];
    if (!data || !wrapperRef.current) return;
    const allZero = data.every(d => d.value === 0);

    const wrapper = wrapperRef.current;
    const svg = d3.select(svgRef.current);

    const { width, height } = wrapper.getBoundingClientRect();

    svg.selectAll("*").remove();
    svg.attr("width", width).attr("height", height);

    const margin = {
      top: 24,
      right: 20,
      bottom: 36,
      left: 48
    };

    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    const g = svg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const xScale = d3
      .scaleBand()
      .domain(data.map(d => d.label))
      .range([0, innerWidth])
      .padding(0.3);

    const yScale = d3
      .scaleLinear()
      .domain([0, d3.max(data, d => d.value)])
      .nice()
      .range([innerHeight, 0]);

    const xAxis = g.append("g")
      .attr("transform", `translate(0,${innerHeight})`)
      .call(d3.axisBottom(xScale));

    xAxis.selectAll("text")
      .attr("transform", "rotate(-30)")
      .style("text-anchor", "end");

    // g.append("g").call(d3.axisLeft(yScale).ticks(4));
    g.append("g")
      .call(
        d3.axisLeft(yScale)
          .ticks(4)
          .tickFormat(d => (d / 1e9) + "B")
      );

    const gradient = svg
      .append("defs")
      .append("linearGradient")
      .attr("id", "barGradient")
      .attr("x1", "0%")
      .attr("y1", "0%")
      .attr("x2", "0%")
      .attr("y2", "100%");

    const tooltip = d3.select("body")
      .append("div")
      .style("position", "absolute")
      .style("background", "#fff")
      .style("padding", "6px 10px")
      .style("border", "1px solid #ccc")
      .style("border-radius", "4px")
      .style("font-size", "12px")
      .style("pointer-events", "none")
      .style("opacity", 0);

    gradient.append("stop")
      .attr("offset", "0%")
      .attr("stop-color", "#f28e2b");

    gradient.append("stop")
      .attr("offset", "100%")
      .attr("stop-color", "#4e79a7");

    if (!allZero) {
      const bars = g
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("x", d => xScale(d.label))
        .attr("y", innerHeight)
        .attr("width", xScale.bandwidth())
        .attr("height", 0)
        .attr("rx", 6)
        .attr("fill", "url(#barGradient)");

      bars
        .transition()
        .duration(700)
        .delay((_, i) => i * 70)
        .ease(d3.easeCubicOut)
        .attr("y", d => yScale(d.value))
        .attr("height", d => innerHeight - yScale(d.value));

      bars
        .on("mouseover", function (event, d) {
          d3.select(this)
            .transition()
            .duration(150)
            .attr("opacity", 0.8);

          tooltip
            .style("opacity", 1)
            .html(`
              <div>
                <strong>Date:</strong> ${d.label}<br/>
                <strong>Value:</strong> ${d.value.toLocaleString()}
              </div>
            `);
        })
        .on("mousemove", function (event) {
          tooltip
            .style("left", event.pageX + 10 + "px")
            .style("top", event.pageY - 20 + "px");
        })
        .on("mouseout", function () {
          d3.select(this)
            .transition()
            .duration(150)
            .attr("opacity", 1);

          tooltip.style("opacity", 0);
        });
    }
  }, [mode, graphData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h6 className={styles.title}>{mode} Counts</h6>

        <div className={styles.selector}>
          {["CAN", "EVENT", "TELEMETRY"].map(item => (
            <button
              key={item}
              onClick={() => setMode(item)}
              className={`${styles.button} ${mode === item ? styles.active : ""
                }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      <div ref={wrapperRef} className={styles.svgWrapper}>
        <svg ref={svgRef} />
      </div>
    </div>
  );
};

export default Barchart;